export enum ExportType {
  None = 'None',
  PaymentSapExport = 'PaymentSapExport',
  PaymentMerinosoftExport = 'PaymentMerinosoftExport',
  PaymentMerinosoftWorkOverPlanExport = 'PaymentMerinosoftWorkOverPlanExport',
  ExportTimesheetToR2Payer = 'ExportTimesheetToR2Payer',
  ExportTimesheetV2ToR2Payer = 'ExportTimesheetV2ToR2Payer',
  ExportTimesheetAmountsToR2Payer = 'ExportTimesheetAmountsToR2Payer',
  ExportTimesheetToEnova = 'ExportTimesheetToEnova',
  ExportTimesheetToEnovaSecondVersion = 'ExportTimesheetToEnovaSecondVersion',
  ExportForeignWorkToEnova = 'ExportForeignWorkToEnova',
  ExportForeignTripsToEnova = 'ExportForeignTripsToEnova',
  OptimaTimesheetExportCsv = 'OptimaTimesheetExportCsv',
  OptimaBasicTripsExportCsv = 'OptimaBasicTripsExportCsv',
  OptimaTimesheetAmountsExport = 'OptimaTimesheetAmountsExport',
  ForeignAllowancesOptimaExport = 'ForeignAllowancesOptimaExport',
  OptimaFreeDaysExport = 'OptimaFreeDaysExport',
  SymfoniaTripsExport = 'SymfoniaTripsExport',
  ExportDriversToExternalSystem = 'ExportDriversToExternalSystem',
  ExportDriverFreeDays = 'ExportDriverFreeDays',
  ExportFullTimesheetToEnova = 'ExportFullTimesheetToEnova',
  DriversListExport = 'DriversListExport',
  PretorExport = 'PretorExport',
  ExportDriversToImi = 'ExportDriversToImi',
  SapPccXmlExport = 'SapPccXmlExport',
  ForeignAllowancesXlsxExport = 'ForeignAllowancesXlsxExport',
  AbsenceExportToR2Payer = 'AbsenceExportToR2Payer',
  UniversalTripPartAmountsExport = 'UniversalTripPartAmountsExport',
  SapTimesheetMabauExport = 'SapTimesheetMabauExport',
  SapTimesheetDaysMabauExport = 'SapTimesheetDaysMabauExport',
  SapTimesheetScheduleMabauExport = 'SapTimesheetScheduleMabauExport',
  TripInvoiceExport = 'TripInvoiceExport',
  GratyfikantExport = 'GratyfikantExport',
  WaproGangSanitarityExport = 'WaproGangSanitarityExport',
  HomelandAllowancesOptimaExport = 'HomelandAllowancesOptimaExport',
  BfmPayrollPreview = 'BfmPayrollPreview',
}
